module.exports = __webpack_public_path__ + "img/nogoplot-min.581af4fa.png";